import {JsonProperty} from '@hyperloris/tyson';

export class ServiceHealthState {

  @JsonProperty()
  serviceName: string | undefined;

  @JsonProperty()
  running: boolean = false;

  @JsonProperty()
  type: ServiceHealthState.TYPE;

  @JsonProperty()
  version: string = '';

}


export module ServiceHealthState {
  export enum TYPE {
    HUB = 'HUB',
    ARCHIVE = 'ARCHIVE',
    GATEWAY = 'GATEWAY',
  }
}
